import { IQuestionnaire } from '../../../shared/types/Case';
import { createApiFetcher } from 'src/utils/ApiUtils';
import { ImsAxiosInstance } from '../axios/axios';
import { IQuestionnaireAnswer, IQuestionnaireDetails, IQuestionnaireDetailsTree } from 'src/shared/types/Questionnaire';

const fetchData = createApiFetcher('questionaire/');

export const getCaseQuestionnaires = (caseId: number): Promise<IQuestionnaire[]> =>
  fetchData<IQuestionnaire[]>('case-questionnaires', { caseId });

export const getQuestionnaireDetails = async (questionnaireId: number): Promise<IQuestionnaireDetails> => {
  const response = await ImsAxiosInstance.get(`api/CaseQuestionnaires/${questionnaireId}`);
  return response.data;
};

export const getQuestionnaireDetailsTree = async (
  questionnaireId: number,
  caseQuestionnaireId: number
): Promise<IQuestionnaireDetailsTree[]> => {
  const response = await ImsAxiosInstance.get(
    `api/QuestionnaireDetailsTree/${questionnaireId}?caseQuestionnaireId=${caseQuestionnaireId}`
  );
  return response.data;
};

export const getQuestionnaireAnswers = async (
  caseQuestionnaireId: number,
  isPrintView: boolean = true
): Promise<IQuestionnaireAnswer[]> => {
  const response = await ImsAxiosInstance.get(
    `api/CaseQuestionnaireAnswers?caseQuestionnaireId=${caseQuestionnaireId}&isPrintView=${isPrintView}`
  );
  return response.data;
};
